import { actionsStyles as styles } from "@solveindustrial/Overrides/Widgets/ProductList/ProductListActions";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        ${styles.wrapper?.css};
        gap: 5px;
    `,
};

styles.bottomSection = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 20px;
        min-height: 2rem;

        &:empty {
            display: none;
        }

        ${mediaQueriesBP.minMD} {
            margin-top: 5px;
        }
    `,
};

styles.addToListWrapper = {
    ...styles.addToListWrapper,
    css: css`
        ${styles.addToListWrapper?.css};
        margin-top: 0;
    `,
};

styles.addToCartButton = {
    ...styles.addToCartButton,
    css: css`
        ${styles.addToCartButton?.css}

        ${mediaQueriesBP.maxMD} {
            min-height: 30px;
            height: 30px;
            font-size: 16px;

            /* width: 100%; */
        }

        ${mediaQueriesBP.minMD} {
            padding: 0 5px;
            flex-basis: 80%;
        }

        ${mediaQueriesBP.minLG} {
            flex-basis: 65%;
            padding: 0 11px;
        }
    `,
};

styles.addToListLink = {
    ...styles.addToListLink,
    link: {
        ...styles.addToListLink?.link,
        typographyProps: {
            variant: "p",
            css: css`
                display: inline-block;
                margin: 0;
            `,
        },
    },
};

styles.addToCartWrapper = {
    ...styles.addToCartWrapper,
    css: css`
        ${styles.addToCartWrapper?.css};
        margin-top: 0;
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: flex-end;
        gap: 8px;
    `,
};

styles.quantityOrdered = {
    ...styles.quantityOrdered,
    cssOverrides: {
        formField: css`
            margin: 0;
            flex-basis: 35%;
            ${mediaQueriesBP.maxLG} {
                font-size: 16px;
                line-height: 30px;
            }
        `,
        formInputWrapper: css`
            input,
            input:not(.react-datetime-picker__inputGroup__input) {
                ${mediaQueriesBP.maxLG} {
                    min-height: 30px;
                    height: 30px !important;
                    font-size: 16px;
                    line-height: 30px;
                }
            }
        `,
    },
    labelProps: {
        ...styles.quantityOrdered?.labelProps,
        weight: 700,
        css: css`
            ${styles.quantityOrdered?.labelProps?.css};
            padding: 0;

            ${mediaQueriesBP.minMD} {
                padding: 0;
            }
        `,
    },
};

styles.learnMoreButton = {
    ...styles.learnMoreButton,
    variant: "primary",
};
